const ZEP_HOST_PATTERN = /(^|\.)zep\.us$/;

interface EmbedContext {
  isTopWindow: boolean;
  /** 최상위 부모 origin. 교차 출처라도 ancestorOrigins 로 읽힌다(Chrome·Safari). */
  topOrigin?: string;
  referrer?: string;
}

/** 부모 호스트를 알 수 없으면 외부로 본다. */
export function isExternalEmbed({
  isTopWindow,
  topOrigin,
  referrer,
}: EmbedContext): boolean {
  if (isTopWindow) return false;
  const source = topOrigin || referrer;
  if (!source) return true;
  try {
    return !ZEP_HOST_PATTERN.test(new URL(source).hostname);
  } catch {
    return true;
  }
}

/** zep.us 밖 사이트가 iframe 으로 품었을 때만 true. */
export function isEmbeddedInExternalHost(): boolean {
  if (typeof window === 'undefined') return false;
  const ancestors = window.location.ancestorOrigins;
  return isExternalEmbed({
    isTopWindow: window.top === window.self,
    topOrigin: ancestors?.[ancestors.length - 1],
    referrer: document.referrer,
  });
}
